import React from 'react';
import Router from './Router';
import './assets/sass/main.scss';

export const App = () => <Router />;


export default App;



// WEBPACK FOOTER //
// ./src/App.js